import app from '../app.first';

app.AdminMatrix = class extends app.Component {
    onReady() {
        this.$template = this.$el.find('[data-template]')
            .remove()
            .clone()
            .removeAttr('data-template')
            .removeClass('hide');

        this.$template.find('.select2').removeClass('select2-hidden-accessible')
            .siblings('.select2-container').remove();

        this.initDeleteListener();
        this.initAddListener();
    }

    initDeleteListener() {
        this.$el.on('click', '[data-remove]', e => {
            $(e.target).closest('[data-item-container]').remove();
            $(document).trigger('matrixUpdated', this);
        });
    }

    initAddListener() {
        this.$el.find('[data-add]').on('click', () => {
            let $lastEl = this.$el.find('[data-item-container]').last();
            let nextKey = 1 + ($lastEl.data('key') || 0);

            const $t = this.$template.clone();

            const $newEl = $t.data('key', nextKey)
                .appendTo(this.$el.find('[data-matrix-container]'))
                .html((index, html) => {
                    return html.split('{key}').join(nextKey).split('-key-').join(`-${nextKey}-`);
                });

            this.$el.find('[data-matrix-container] [data-component]').setClass().trigger('load');
            app.initSelect2();

            $(document).trigger('matrixUpdated', this);
        });
    }
}